module.exports = __webpack_public_path__ + "img/im4.06e4c37b.png";